import { useCallback, useMemo } from 'react';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { LOCALES } from '../../constants/Locales';
import { captureException } from '../../utils/captureException';
import useLocaleContext from '../../hooks/useLocaleContext';
import { localeI18nText } from '../../utils/localeI18nText';
import { trackInteraction } from '../../utils/usageTracker';
import { Select } from '../Select';
import { INTERACTIONS } from '../../constants/TrackingConstants';
import { jsx as _jsx } from "react/jsx-runtime";
export const LanguageSelect = () => {
  const {
    locale,
    updateLocale
  } = useLocaleContext();
  const options = useMemo(() => LOCALES.map(_locale => {
    const key = `app.language.options.${_locale}`;
    const isKeyValid = isValidI18nKey(key);
    if (!isKeyValid) {
      captureException(new Error(`Lang Select: Invalid i18n key: ${key}`), ['invalid-i18n-key']);
    }
    return {
      text: isKeyValid ? localeI18nText(key, _locale) : _locale,
      value: _locale
    };
  }), []);
  const onLanguageChange = useCallback(({
    target: {
      value
    }
  }) => {
    updateLocale(value);
    trackInteraction({
      interaction: INTERACTIONS.LOCALE_CHANGE,
      locale: value
    });
  }, [updateLocale]);
  return /*#__PURE__*/_jsx(Select, {
    buttonUse: "transparent",
    className: "p-x-0 p-bottom-5",
    "data-test-id": "language-select",
    menuWidth: 250,
    options: options,
    value: locale,
    onChange: onLanguageChange
  });
};